import abortableFetch from "./abortableFetch";
import { shallowRef } from "vue";


/**
 * Klasse, für wiederholbare Requests für Autocompleter, Paging bei Tabellen oder ähnliches, 
 * wo es vorteilhaft ist vorherige Requests abzubrechen um Raceconditions zu vermeiden.
 * hat auch ein Ref, das gesetzt wird, wenn grad ein Request läuft.
 * 
 * Nutzung: Instanz anlegen und dann wie normales fetch benutzen.
 * 
 * const a = new SingleFetch();
 * a.fetch("hierstehtmeineurl").then
 * 
 */

// let i = 0;
export default class SingleFetch{

  constructor() {
    this.abortableFetch = null;
    this.isRequesting = shallowRef(false);
  }

  async fetch() {
    let args = arguments;
    // let _i = i++;
    if (this.abortableFetch) {
      this.abortableFetch.abort();
      this.abortableFetch = null;
    }
    let thisFetch = this.abortableFetch = abortableFetch.apply(null, arguments);
    this.isRequesting.value = true;

    let catchAbort = this.abortableFetch.ready;
    let fin = (e) => {
      // console.log(_i,"find", this, e)
      if (thisFetch === this.abortableFetch) { // der letzte macht das Licht aus
        this.isRequesting.value = false;
        this.abortableFetch = null;
        // console.log(_i,"finished", this)
      }
      else {
        // console.log(_i,"aborted", this)
        // throw new Error("aborted");
      }
    }


    let wrapConsume = (origResp, functionName) => {
      return () => {
        return origResp[functionName]().finally(fin);
      }
    };

    return catchAbort.then(/**@type {Response} */ e => {
      return {
        origResp: e,
        text: wrapConsume(e, "text"),
        blob: wrapConsume(e, "blob"),
        json: wrapConsume(e, "json"),
        arrayBuffer: wrapConsume(e, "arrayBuffer"),
      }
    }).catch((e) => {
      fin();
      throw e;
    });
  }
}